import { Plus, X } from 'lucide-react';
import React, { FC } from 'react';

import { AddSwatch, SwatchItem, SwatchRow } from './Settings.styled';

interface ColorListEditorProps {
  colors: string[];
  onChange: (colors: string[]) => void;
  max: number;
}

/**
 * Lista kolorów z natywnym próbnikiem systemu. Zapis `#rrggbb` gwarantuje
 * `input type="color"`, więc walidacja po stronie backendu jest tu ostatnią
 * zaporą, a nie codzienną ścieżką.
 */
export const ColorListEditor: FC<ColorListEditorProps> = ({ colors, onChange, max }) => {
  const add = (color: string): void => {
    const normalized = color.toLowerCase();
    if (colors.includes(normalized) || colors.length >= max) return;
    onChange([...colors, normalized]);
  };

  return (
    <SwatchRow>
      {colors.map((color) => (
        <SwatchItem key={color} $color={color} title={color.toUpperCase()}>
          <button type="button" aria-label={`Usuń kolor ${color}`} onClick={() => onChange(colors.filter((item) => item !== color))}>
            <X size={11} />
          </button>
        </SwatchItem>
      ))}

      {colors.length < max && (
        <AddSwatch title="Dodaj kolor">
          <Plus size={16} />
          <input
            type="color"
            aria-label="Dodaj kolor"
            onChange={(event) => add(event.target.value)}
          />
        </AddSwatch>
      )}
    </SwatchRow>
  );
};
